import postHog from "@/config/posthog";

export enum FiaTrackingEvent {
  DunningBlockSet = "FIA_DUNNING_BLOCK_SET",
  DunningBlockRemove = "FIA_DUNNING_BLOCK_REMOVE",
  OpenPositionViewModeSelected = "FIA_OPEN_POSITION_VIEW_MODE_SELECTED",
}

export enum FiaTrackingSource {
  OpenPositions = "fia-open-positions",
  CustomerDetail = "customer-detail",
  BranchDetail = "branch-detail",
}

interface FiaTrackingProperties {
  [FiaTrackingEvent.DunningBlockSet]: { source: FiaTrackingSource };
  [FiaTrackingEvent.DunningBlockRemove]: { source: FiaTrackingSource };
  [FiaTrackingEvent.OpenPositionViewModeSelected]: { mode: string };
}

export function trackFiaEvent<E extends FiaTrackingEvent>(event: E, properties: FiaTrackingProperties[E]): void {
  postHog.capture(event, properties);
}
